export const getContainerQrCodeImgUrl = (containerId, containerShortId) =>
  `/container/QrCodeForContainer?${
    containerShortId
      ? 'shortId=' + containerShortId
      : 'containerId=' + containerId
  }`;

export const getUserQrCodeImgUrl = (userId) =>
  `/Users/QrCodeForUser/${userId}/false`;
